/**
 * @file.
 * Contains Bridge service.
 */

import { log } from 'common/utils/logging.util';
import { IS_DISONA } from 'common/utils/style.util';

const needToBeJSONed = (str) => {
  const res = false;
  if (['{', '['].includes(String(str)[0])) return true;
  if (!isNaN(Number(str[0]))) return true;
  return res;
};

export const LocalStorage = {
  set: (key, data) => {
    let dataToBeWritten = data;
    try {
      if (needToBeJSONed(dataToBeWritten))
        dataToBeWritten = JSON.stringify(data);
      window.localStorage.setItem(key, dataToBeWritten);
    } catch (e) {
      console.log('can not set to localstorage');
    }
  },
  get: (key) => {
    try {
      const readData = window.localStorage.getItem(key);
      const isNeedToBeParsed = needToBeJSONed(readData);
      return isNeedToBeParsed ? JSON.parse(readData) : readData;
    } catch (e) {
      log(`can not get *${key}* from localstorage`, 'warn');
      return null;
    }
  },
};

export const getSelectedSymbolName = (accountNumber) => {
  const today = new Date();
  const weekendDaysUTC = today.getUTCDay();
  const hoursUTC = today.getUTCHours();
  const minutesUTC = today.getUTCMinutes();
  const time = `${hoursUTC}:${minutesUTC}`;

  if (IS_DISONA && weekendDaysUTC === 5 && time > '21:50') {
    LocalStorage.set(`selectedSymbolName:${accountNumber}`, 'BTCUSD.ds');
  } else if (IS_DISONA && weekendDaysUTC === 6) {
    LocalStorage.set(`selectedSymbolName:${accountNumber}`, 'BTCUSD.ds');
  } else if (IS_DISONA && weekendDaysUTC === 0 && time < '22:00') {
    LocalStorage.set(`selectedSymbolName:${accountNumber}`, 'BTCUSD.ds');
  } else {
    LocalStorage.get(`selectedSymbolName:${accountNumber}`);
  }
};

export const getAccountSettingsFromLS = (accountNumber) => ({
  timeFrame: +LocalStorage.get(`timeFrame:${accountNumber}`) || 1,
  instruments: LocalStorage.get(`instruments:${accountNumber}`) || [],
  selectedSymbolName: getSelectedSymbolName(accountNumber),
  chartType: LocalStorage.get(`chartType:${accountNumber}`) || 'LINE',
});
